<template>
  <div v-loading="!complete">
    <div>
      <div class="c-gray m-b-20">
        <div class="fr m-r-20 pointer" @click="openHistroy()">
          <i class="fa fa-clock-o"></i>&nbsp;&nbsp;流程历史
        </div>
        <div class="fr m-r-40 pointer pos-rel" @mouseover="openLog()" @mouseout="closeLog()">
          <i class="fa fa-dot-circle-o"></i>&nbsp;&nbsp;流程状态
          <flow-log v-show="showLog" :caseId="caseId"></flow-log>
        </div>
        <div style="clear: both"></div>
      </div>
      <commonFormRender
        ref="form"
        :form="form"
        :formField="formField"
        :modelId="modelId"
        :isReadonly="isReadonly"
        :complete="complete">
        <flow-histroy :modalShow="modalShow" :caseId="caseId" @closeHistroy="closeHistroy"></flow-histroy>
        <el-table
          v-if="examineList && examineList.length>0"
          :data="examineList"
          class="m-t-10"
          style="width: 100%">
          <el-table-column
            prop="create_time"
            label="审批时间">
            <template scope="scope">
              <span>{{ scope.row.create_time | parseTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="node_name"
            label="审批节点">
          </el-table-column>
          <el-table-column
            prop="realname"
            label="审批人">
          </el-table-column>
          <el-table-column
            prop="content"
            label="审批意见">
            <template scope="scope">
              <span v-if="scope.row.examine_status == 10">{{ scope.row.content}}</span>
              <span v-else style="color:#ff4949">{{ scope.row.content }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-60  pos-rel top-title">
          <div class="flowDetail-btns">
            <el-button type="primary" v-show="saveBtnShow" @click="add(2)" :loading="isLoading"><i class="fa fa-floppy-o"></i>&nbsp;&nbsp;保存</el-button>
            <el-button type="primary" v-show="endBtnShow" @click="endFlow()"><i class="fa fa-power-off"></i>&nbsp;&nbsp;结束流程</el-button>
            <el-button type="warning" v-show="examineShow" @click="addDialog(0)" :loading="isLoading"><i class="fa fa-reply"></i>&nbsp;&nbsp;回退</el-button>
            <el-button type="success" v-show="submitShow && caseNode.type ==30" @click="addDialog(1)" :loading="isLoading"><i class="fa fa-upload"></i>&nbsp;&nbsp;提交</el-button>
            <el-button type="success" v-show="submitShow && caseNode.type !=30" @click="add(1)" :loading="isLoading"><i class="fa fa-upload"></i>&nbsp;&nbsp;提交</el-button>
            <el-button type="danger" v-show="canRetract" @click="retractFlow" :loading="isLoading"><i class="fa fa-reply"></i>&nbsp;&nbsp;撤回</el-button>
            <el-button type="danger" v-show="stopShow" @click="stopFlow()" :loading="isLoading"><i class="fa fa-close"></i>&nbsp;&nbsp;终止</el-button>
          </div>
          <el-button @click="goback()">返回</el-button>
        </div>
      </commonFormRender>
    </div>
    <!--<el-button style="position: absolute;top:12px;left:10px" @click="goback()">返回</el-button>-->
    <flow-process-dialog
      ref="flowProcessControl"
      v-if="currentData.currentType !== UESR_CONSTANT"
      :currentData="currentData"
      @handleDialogResult="handleDialogResult">
    </flow-process-dialog>

    <el-dialog :title="examinationTitle" ref="examinationDialog" v-if="">
      <el-form :model="form">
        <el-form-item label="填写内容">
          <el-input
            type="textarea"
           :placeholder="填写审批内容"
            v-model="examine_opinion">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeExaminationDialog">返 回</el-button>
        <el-button type="primary" @click="add(isPass)">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.top-title {
  /*position: absolute;*/
  /*bottom: 0px;*/
  /*left: 0px;*/
  width: 100%
}
.flowDetail-btns {
  position: absolute;
  top: 0px;
  right: 10px
}
.pointer:hover {
  cursor: pointer
}
</style>

<script>
  import http from '../../../assets/js/http'
  import modelConfig from '../../../config/modelConfig'
  import _verify from '../../../assets/js/verify'
  import commonFormRender from '../../Common/business/render/commonFormRender'
  import flowHistroy from './histroy.vue'
  import flowLog from './log.vue'
  import flowProcessDialog from './flowProcessDialog.vue'
  export default {
    name: 'flowDetail',
    data() {
      return {
        modalShow: false,
        showLog: false,
        stopShow: false, // 是否显示终止按钮
        type_id: null,
        type: null,       // 1：我的待办；2：经办跟踪；3：数据管理
        caseId: null,
        nodeId: null,
        examine: false,
        manage_uid: null,
        modelId: -1,
        caseNodeId: '',
        editors: [],
        isLoading: false,
        formField: [],
        form: {},
        host: '',
        fileType: [
          { id: 10, name: '图片' },
          { id: 20, name: '压缩文件' },
          { id: 30, name: 'word文档' },
          { id: 40, name: 'excel表格' },
          { id: 50, name: 'ppt幻灯片' },
          { id: 60, name: 'PDF' }
        ],
        complete: false,
        nodeType: null, // 节点类型
        examineStatus: 10, // 审批状态
        connectType: null, // 连接状态
        nextIden: null, // 流向节点
        nextNode: [], // 流向节点选择数组
        groups: [],
        keyData: {},
        currentData: {
          currentType: 10, // 当前选择类型
          currentContent: [] // 当前数组
        },
        caseNode: {},
        examinationTitle: '',
        examinationPlaceholder: '',
        isPass: '',
        examine_opinion: '',
        examineList: [],
        noEmpty: 0,
        number: 0,
        canRetract: false // 是否可撤回
      }
    },
    components: {
      commonFormRender,
      flowHistroy,
      flowLog,
      flowProcessDialog
    },
    filters: {
      parseTime(item) {
        return moment.unix(item).format('YYYY-MM-DD')
      }
    },
    async created() {
      this.isLoading = true
      this.type_id = this.$route.query.type_id
      this.nodeId = this.$route.query.node_id
      this.type = this.$route.query.type
      if (this.type == 4) {
        this.canRetract = await this.checkCanRetract()
      }
      this.caseId = parseInt(this.$route.params.id)
      this.host = HOST
      this.getDataInfo()
      if (this.caseId) {
        this.initExamineOpinion()
      }
    },
    methods: {
      openExaminationDialog() {
        this.$refs.examinationDialog.open()
      },
      closeExaminationDialog() {
        this.$refs.examinationDialog.close()
      },
      initExamineOpinion() {
        this.apiGet(`bpm/flowCases/examineOpinion/${this.caseId}`).then((res) => {
          if (res.code == 200) {
            this.examineList = res.data
          }
        })
      },
      isReadonly(item) {
        return item.default.field_auth == 10 || this.type != 1
      },
      getDataInfo() {
        if (this.type == 1) {
          this.getNodeDetail()
        } else if (this.type == 2) {
          this.getFollowDetail()
        } else {
          this.getDataDetail()
        }
      },
      getNodeDetail() {       // 我的待办
        this.apiGet(`bpm/cases/${this.caseId}/nodes/${this.nodeId}`).then((res) => {
          this.isLoading = false
          this.caseNode = res.data.caseNode
          if (res.code == 200) {
            if (res.data.caseNode && res.data.caseNode.type == 30) {
              this.examine = true
            }
            if (res.data.caseInfo && res.data.caseInfo.manage_uid) {
              this.manage_uid = res.data.caseInfo.manage_uid
            }
            let canStop = res.data.caseInfo.can_stop || 0
            let userId = Lockr.get('userInfo').id
            if (canStop == 1 && res.data.caseInfo.user_id == userId) {
              this.stopShow = true
            }
            this.formField = res.data.nodeField
            this.modelId = res.data.modelId
            // 处理返回下一节点数据
            if (res.data.nextNodeConfig) {
              this.handleNextNodeConfig(res.data.nextNodeConfig)
            }
            this.initData(res)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getFollowDetail() {     // 经办跟踪
        this.apiGet(`bpm/flowCases/${this.caseId}/catch`).then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            if (res.data.caseNode && res.data.caseNode.manage_uid) {
              this.manage_uid = res.data.caseNode.manage_uid
            }
            this.formField = res.data.formField
            this.initData(res)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getDataDetail() {     // 数据管理
        this.apiGet(`bpm/types/${this.type_id}/cases/${this.caseId}`).then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            if (res.data.caseInfo && res.data.caseInfo.manage_uid) {
              this.manage_uid = res.data.caseInfo.manage_uid
            }
            this.formField = res.data.formField
            this.initData(res)
          } else {
            _g.dealError(this, res)
          }
        })
      },
      async checkCanRetract() { // 检查是否可撤回流程
        let res = await this.apiGet(`bpm/flowCases/checkCanRetract/${this.nodeId}`)
        let data = false
        if (res.code == 200) {
          data = res.data
        } else {
          data = false
          _g.dealError(this, res)
        }
        return data
      },
      initData(res) {
        this.form = res.data.formData
        this.complete = true
      },
      handleNextNodeConfig(nextNodeConfig) {
        if (nextNodeConfig && nextNodeConfig.flag !== 10) {
          let type = nextNodeConfig.flag
          this.currentData.currentType = type
          if (type === this.USER_GROUP) {
            nextNodeConfig.groups = this.handleDefaultSelected(nextNodeConfig.group)
            this.currentData.currentContent = nextNodeConfig.groups
          } else if (type === this.USER_DEPARTMENT) {
            nextNodeConfig.departments = this.handleDefaultSelected(nextNodeConfig.departments)
            this.currentData.currentContent = nextNodeConfig.departments
          }
        }
      },
      handleDialogResult(data, postData) {
        postData = this.extractCurrentData(data, postData)
        this.post(postData)
      },
      handleDefaultSelected(arr) { // 给每个数据加上selected
        if (arr && arr.length > 0) {
          _(arr).forEach((res, index) => {
            res.selected = false
            if (res.list && res.list.length > 0) {
              _(res.list).forEach((childRes, childIndex) => {
                childRes.selected = false
              })
            }
          })
        }
        return arr
      },
      handleSubmitData(postData) {
        let self = this
        let type = this.currentData.currentType
        let content = this.currentData.currentContent
        if (type !== this.UESR_CONSTANT && content && content.length > 0) {
          if (content.length === 1) {
            // 只有一个用户组，用户组的数据小于等于一个
            if (content[0].list && content[0].list.length <= 1) {
              let arr = []
              if (content[0].list.length === 1) {
                arr.push(content[0].list[0].id)
              }
              postData = this.extractCurrentData(arr, postData)
              if (this.number == 0) {
                this.post(postData)
                this.number++
              }
              setTimeout(() => {
                this.number = 0
              }, 1200)
              return
            }
          }
          setTimeout(() => {
            self.$refs.flowProcessControl.openDialog(postData)
          })
        } else {
          this.post(postData)
        }
      },
      extractCurrentData(arr, postData) {
        postData.receivers = arr
        postData.flag = this.currentData.currentType
        // 过滤只剩下数据id
        return postData
      },
      addDialog(isPass) {
        this.examinationTitle = ''
        this.isPass = isPass
        if (isPass === 0) {
          // 回退操作
          if (!this.caseNode.config.rollback_dialog_config) {
            this.caseNode.config.rollback_dialog_config = {
              title: '审批意见',
              placeholder: '不同意',
              allowEmpty: 0
            }
          }
          this.noEmpty = this.caseNode.config.rollback_dialog_config.allowEmpty
          this.examinationTitle = this.caseNode.config.rollback_dialog_config.title
          this.examine_opinion = this.caseNode.config.rollback_dialog_config.placeholder
        } else if (isPass === 1) {
          if (!this.caseNode.config.pass_dialog_config) {
            this.caseNode.config.pass_dialog_config = {
              title: '审批意见',
              placeholder: '同意',
              allowEmpty: 0
            }
          }
          this.noEmpty = this.caseNode.config.pass_dialog_config.allowEmpty
          this.examinationTitle = this.caseNode.config.pass_dialog_config.title
          this.examine_opinion = this.caseNode.config.pass_dialog_config.placeholder
        }
        this.openExaminationDialog()
      },
      add(isPass) {
        let postData = _.cloneDeep(this.form)
        let data = null
        if (JSON.stringify(this.rules) != '{}' && isPass !== 0) {
          this.$refs.form.validate((pass) => {
            if (pass) {
              data = this.getPostData(postData, isPass)
              if (isPass === 1) {
                data['examine_opinion'] = this.examine_opinion
                if (this.noEmpty == 1) {
                  if (data['examine_opinion'] == '') {
                    _g.toastMsg(this, 'error', '填写内容不能为空')
                    return
                  }
                }
                this.handleSubmitData(data)
                return
              }
              if (this.number == 0) {
                this.post(data)
                this.number++
              }
              setTimeout(() => {
                this.number = 0
              }, 1200)
            }
          })
        } else {
          data = this.getPostData(postData, isPass)
          if (isPass === 1) {
            // 提交操作
            data['examine_opinion'] = this.examine_opinion
            this.handleSubmitData(data)
            return
          }
           // 回退操作
          data['examine_opinion'] = this.examine_opinion
          if (this.noEmpty == 1) {
            if (this.examine_opinion == '') {
              _g.toastMsg(this, 'error', '填写内容不能为空')
              return
            }
          }
          if (this.number == 0) {
            this.post(data)
            this.number++
          }
          setTimeout(() => {
            this.number = 0
          }, 1200)
        }
      },
      getPostData(data, type) {
        if (type == 2) {
          // 保存
          data.isFlow = 0
        } else if (type == 0) {
          data.isFlow = 1
          data.examine_status = 20
        } else if (type == 1) {
          data.isFlow = 1
          if (this.examine) {
            data.examine_status = 10
          }
        }
        data.flag = this.currentData.currentType
        return data
      },
      post(postData) {
        this.isLoading = !this.isLoading
        this.apiPut(`bpm/cases/${this.caseId}/nodes/${this.nodeId}`, '', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '提交成功')
            this.closeExaminationDialog()
            setTimeout(() => {
              this.goback()
            }, 1500)
          } else {
            this.isLoading = !this.isLoading
            this.closeExaminationDialog()
            _g.dealError(this, res)
          }
        })
      },
      goback() {
        router.go(-1)
      },
      endFlow() {
        this.isLoading = !this.isLoading
        this.apiPut(`bpm/flowCases/${this.caseId}/end`, '').then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '流程已结束')
            setTimeout(() => {
              this.goback()
            }, 1500)
          } else {
            this.isLoading = !this.isLoading
            _g.dealError(this, res)
          }
        })
      },
      stopFlow() {
        this.$confirm('此操作将终止该流程, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isLoading = true
          this.apiPut(`bpm/flowCases/${this.caseId}/stop`, '' , { case_id: this.caseId }).then((res) => {
            this.isLoading = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '终止成功'
              })
              this.$router.go(-1)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      retractFlow() {
        this.$confirm('此操作将撤回该流程, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.isLoading = true
          let res = await this.apiGet(`bpm/flowCases/retractCase/${this.nodeId}`)
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '撤回成功')
            this.$router.go(-1)
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        }).catch(() => {
          _g.toastMsg(this, 'normal', '已取消')
        })
      },

      openHistroy() {
        this.modalShow = true
      },
      closeHistroy() {
        this.modalShow = false
      },
      openLog() {
        this.showLog = true
      },
      closeLog() {
        this.showLog = false
      }
    },
    computed: {
      saveBtnShow() {
        return this.type == 1
      },
      submitShow() {
        return this.type == 1
      },
      examineShow() {
        return this.examine && this.type == 1
      },
      endBtnShow() {
        return this.manage_uid == Lockr.get('userInfo').id && this.type == 3
      }
    },
    mixins: [http, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// detail.vue?08cd56f8